import React from "react";
import { connect } from "react-redux";
import "../Static/Styles//LeaderBoard.css";
import { Redirect } from "react-router-dom";

function LeaderBoard(props:any) {
  if (props.isLogged === false) {
    return <Redirect to="/" />;
  }
  function getUserAnsweredQuesrions(user:any) {
    if (user) {
      const count = Object.keys(user.answers).length;
      return count;
    }
    return 0;
  }
  function getUserCreatedQuesrions(user:any) {
    if (user) {
      const count = Object.keys(user.questions).length;
      return count;
    }
    return 0;
  }

  function getUserScore(user:any) {
    return getUserAnsweredQuesrions(user) + getUserCreatedQuesrions(user);
  }

  function LeaderBoard(obj:any) {
    const { user } = obj;
    return (
      <div className="wrapper">
        <div className="cols">
          <div
            className="lcol"
            onTouchStart={(e:any) => e.target.classList.toggle("hover")}
          >
            <div className="lcontainer">
              <div className="front">
                <img className="image" src={obj.user.avatarURL} alt="avatar" />
                <div className="inner">
                  <p>{user.name}</p>
                  <span>Score</span>
                  <br />
                  <span>{getUserScore(user)}</span>
                </div>
              </div>
              <div className="back">
                <div className="">
                  <p>Answered Questions</p>
                  <p>{getUserAnsweredQuesrions(user)}</p>
                  <p>Created Questions</p>
                  <p>{getUserCreatedQuesrions(user)}</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }

  for (const user of props.users) {
    user.score = getUserScore(user);
  }

  return (
    <>
      {props.users
        .sort((a:any, b:any) => (a.score < b.score ? 1 : -1))
        .map((user:any) => (
          <LeaderBoard key={user.id} user={user} />
        ))}
    </>
  );
}

const mapStateToProps = (state:any) => {
  return {
    users: state.userReducer.users,
    isLogged: state.userReducer.loggedUser.id ? true : false,
  };
};

export default connect(mapStateToProps, null)(LeaderBoard);
